export const NEW_INSTALLMENT_APPLICATION_URL = 'nova';

export const MIN_EXTRAORDINARY_PAYMENT_AMOUNT = 10000;

export const MIN_EARLY_PAYMENT_AMOUNT = 10000;
